import { render, staticRenderFns } from "./InformeMain.vue?vue&type=template&id=6b725582&scoped=true&"
import script from "./InformeMain.vue?vue&type=script&lang=js&"
export * from "./InformeMain.vue?vue&type=script&lang=js&"
import style0 from "./InformeMain.vue?vue&type=style&index=0&id=6b725582&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b725582",
  null
  
)

export default component.exports